var render, staticRenderFns
import script from "./VBtn.vue?vue&type=script&lang=ts"
export * from "./VBtn.vue?vue&type=script&lang=ts"
import style0 from "./VBtn.vue?vue&type=style&index=0&id=71af7b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af7b7a",
  null
  
)

export default component.exports